import { autocompleteSearch } from './aktiv-autocomplete-broker-search';
import $ from 'jquery';
import 'jquery-ui-autocomplete';

const initAutocomplete = (containerID, translates) => {
  const $container = $('#' + containerID);
  const $aktivSearchResult = $container.find('#aktiv-search-result-' + containerID);

  const $autocomplete = $container.find('.aktiv-ui-autocomplete-input').autocomplete({
    appendTo: $aktivSearchResult,
    select: (event, ui) => {
      location.href = ui.item.url; // CLick on search item
    },
    source: (request, response) => {
      autocompleteSearch(request.term).then((responses) => {
        if (responses.length > 0) {
          response(responses);
        } else {
          response([
            {
              value: translates.noHits,
            },
          ]);
        }
      }, () => {
        response([
          {
            value: translates.errorMsg,
          },
        ]);
      });
    },
  });

  // Override default rendering of items
  $autocomplete.data('ui-autocomplete')._renderItem = (ul, item) => {
    return $('<li>')
      .html(`<a href="${item.url}">${item.value}</a>`)
      .appendTo(ul);
  };

  $autocomplete.on('input', () => {
    $autocomplete.val();
  });
};

export { initAutocomplete };